import { refreshReducersToInitial } from "../../../action";
import { CustomAddress, GoogleTowInfo } from "../../../types";

export const CLEAR_CUSTOM_ADDRESS = "@@DROPOFF_LOCATION_SELECTION/CLEAR_CUSTOM_ADDRESS" as const;
export const SET_CUSTOM_ADDRESS = "@@DROPOFF_LOCATION_SELECTION/SET_CUSTOM_ADDRESS" as const;
export const SET_CUSTOM_ADDRESS_ERROR = "@@DROPOFF_LOCATION_SELECTION/SET_CUSTOM_ADDRESS_ERROR" as const;
export const SET_CUSTOM_ADDRESS_SUCCESS = "@@DROPOFF_LOCATION_SELECTION/SET_CUSTOM_ADDRESS_SUCCESS" as const;

export type CustomAddressSuccessPayload = {
  towInfo: GoogleTowInfo;
} & CustomAddress;

export const clearCustomAddress = () =>
  ({
    type: CLEAR_CUSTOM_ADDRESS,
  } as const);

export const setCustomAddress = (payload: CustomAddress) =>
  ({
    type: SET_CUSTOM_ADDRESS,
    payload,
  } as const);

export const setCustomAddressError = (payload) =>
  ({
    type: SET_CUSTOM_ADDRESS_ERROR,
    payload,
  } as const);

export const setCustomAddressSuccess = (payload: CustomAddressSuccessPayload) =>
  ({
    type: SET_CUSTOM_ADDRESS_SUCCESS,
    payload,
  } as const);

export type SetCustomAddressAction = ReturnType<typeof setCustomAddress>;

export type SetCustomAddressActions =
  | SetCustomAddressAction
  | ReturnType<typeof clearCustomAddress>
  | ReturnType<typeof setCustomAddressError>
  | ReturnType<typeof setCustomAddressSuccess>
  | ReturnType<typeof refreshReducersToInitial>;
